import { isAfter, parseISO } from 'date-fns';
import { useSubscription } from '../entities/subscription';
import { useCurrentOrg, useFeatureAccess } from '../entities/user';

export const useNeedsToCreateSubscription = () => {
  const { org } = useCurrentOrg();
  const { data: subscription } = useSubscription();
  const isManageLead = useFeatureAccess('MANAGE_LEAD');

  if (isManageLead) return false;

  if (
    subscription &&
    'is_active_free_trial' in subscription &&
    subscription.is_active_free_trial &&
    subscription.trial_end
  )
    return isAfter(new Date(), parseISO(subscription.trial_end));

  if (org?.is_non_profit) return false;

  return !subscription;
};
